import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20luxury%20residential%20community%20entrance%20with%20modern%20architecture%2C%20warm%20golden%20hour%20lighting%2C%20lush%20landscaped%20gardens%2C%20premium%20lifestyle%20aesthetic%2C%20clean%20lines%2C%20sophisticated%20design%2C%20marble%20and%20wood%20textures%2C%20atmospheric%20and%20inviting&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
          alt="精品八区高端生活社区"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-white/80 tracking-[0.3em] uppercase mb-4 font-label">
            Premium District · 精品八区
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            汇聚高端精选<br className="md:hidden" />
            尊享品质生活
          </h1>
          <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed mb-10">
            精品八区，为追求卓越的您打造一站式高端生活解决方案。
            精品居住、优质服务、专属权益——您的品质生活，从这里开始。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3 text-sm font-medium whitespace-nowrap cursor-pointer rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 shadow-[0_4px_20px_rgba(0,0,0,0.15)]"
            >
              探索精品八区
            </Link>
            <Link
              to="/category/premium-residence"
              className="px-8 py-3 text-sm font-medium whitespace-nowrap cursor-pointer rounded-full border border-white/30 text-white hover:bg-white/10 transition-all duration-300"
            >
              浏览精选资源
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl" />
      </div>
    </section>
  );
}